<div class="mt-4 mb-0 sm:mb-4 sm:mt-0">
	<button
		(click)="onNavigateBack()"
		class="flex items-center mb-4 shadow-sm cursor-pointer sm:inline-flex btn-y-2 secondary-button focus:outline-none group group-hover:text-white"
	>
		<uc-arrow-long-left-svg
			customStyles="mr-3 text-gray-700 group-hover:text-white text-uc-blue-900"
		/>
		Back to all courses
	</button>
</div>
